// eslint-disable-next-line max-len
const strReplaceAll = (needles, haystack) => needles.reduce((replacedText, needle) => replacedText.replace(new RegExp(needle.original, 'g'), needle.translated), haystack);

module.exports = strReplaceAll;
